var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.945 9.216V8.138h-.527v1.078a.26.26 0 01-.258.258H.784a.26.26 0 01-.258-.258V.784A.26.26 0 01.784.526H6.16a.26.26 0 01.258.258v1.078h.527V.784A.786.786 0 006.16 0H.784A.786.786 0 000 .784v8.432c0 .432.352.784.784.784H6.16a.786.786 0 00.785-.784zm2.982-4.398l.051.077a.263.263 0 01-.055.291L7.56 7.548l-.372-.373L9.1 5.263H2.785c-.346 0-.346-.526 0-.526h6.316L7.19 2.825l.372-.372 2.366 2.365z",
    fill: "#485057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.471f19498de1c8dab448d9d944f021a7.svg";
export { ForwardRef as ReactComponent };